import { paths } from '@/constants/paths'
import { Seo } from '@/layout/Seo'
import { useCanonicalUrl } from '@/layout/Seo/useCanonicalUrl/useCanonicalUrl'
import { LegalLayout } from '@/layouts/LegalLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import { Privacy_2025_03_18 } from './2025-03-18'

const PrivacyPage: NextPageWithLayout = () => {
  const canonical = useCanonicalUrl(paths.legal.privacyPolicy)
  const title = 'Privacy Policy | Angel'

  return (
    <>
      <Seo
        canonical={canonical}
        title={title}
        description="Angel Privacy Policy. Learn how we collect, use, and protect your personal information."
        openGraph={{
          title,
          url: canonical,
          site_name: 'Angel',
        }}
        path={paths.legal.privacyPolicy}
      />
      <Privacy_2025_03_18 />
    </>
  )
}

PrivacyPage.getLayout = (page) => {
  return <LegalLayout>{page}</LegalLayout>
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/legal/privacy/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'account'])),
      },
      revalidate: false,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default PrivacyPage
